import axios from 'axios';

const normalizeBaseUrl = (url) => {
  if (!url) {
    return "/api/v1.0/frontend/"
  }
  return url.endsWith('/') ? url : `${url}/`
}

const envBaseURL = process.env.REACT_APP_API_URL;
const baseURL = normalizeBaseUrl(envBaseURL);

const instance = axios.create({ baseURL });

export default instance;

